define('Videos.Cell.View'
    , [
        'videos_cell.tpl'

        , 'Backbone'
        , 'Backbone.CompositeView'
        , 'underscore'
    ]
    , function (
        videos_cell_tpl

        , Backbone
        , BackboneCompositeView
        , _
    ) {
        'use strict';

        // @class Videos.Cell.View @extends Backbone.View
        return Backbone.View.extend({

            template: videos_cell_tpl

            , initialize: function (options) {
                this.collection = options.collection;

                BackboneCompositeView.add(this);
            }

            //@method getContext @return Videos.Cell.View.Context
            , getContext: function getContext() {
                //@class Videos.View.Context
                return {
                    youtubeVideos: this.collection.models
                };
            }
        });
    });
